import React from 'react'
import './Questions.css'
import { Link } from 'react-router-dom'
import Navbar from '../HomeComponents/Navbar';

export default function SideQ() {
    return (
        <>
            <Navbar />
            <nav className="sidenav-slim">
                <ul>
                   
                    <li className="side-list"><Link to="/question/8">EIGHT</Link></li>
                    <li className="side-list"><Link to="/question/9">NINTH</Link></li>
                    <li className="side-list"><Link to="/question/10">TENTH</Link></li>
                    <li className="side-list"><Link to="/question/11">Eleventh</Link></li>
                    <li className="side-list"><Link to="/question/12">Twelvth</Link></li>
             
          
                </ul>
                 {/* <img src={analytics} className="a-img" alt="" />  */}
            </nav>
        </>
    )
}
